// extracted by mini-css-extract-plugin
module.exports = {"container":"MB","noResults":"NB","contact":"OB"};